import Vue from 'vue'
import VueRouter from 'vue-router'

import competitions from './routes/competitions'
import login from './routes/login'
import error404 from './routes/error404'
import termsAndConditions from './routes/terms-and-conditions'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [...competitions, ...login, ...termsAndConditions, ...error404],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.hash) {
        return {
          selector: to.hash
        }
      }
      return { x: 0, y: 0 }
    }
  }
})

export default router
